import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableItem } from '@nu-art/thunderstorm-frontend/index';
import { Pathway_GraphView } from '@app/pathway-frontend';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_Advisor_PathwayState, ModuleFE_Advisor_PathwayTransition } from '@app/advisor-frontend';
import { capitalizeAllFirstLetters, MUSTNeverHappenException } from '@nu-art/ts-common';
import { TransitionCondition } from '@app/pathway-shared';
import { ModuleFE_RuntimeActiveNavState } from '@app/advisor-frontend';
import { Advisor_DialogConfirmation } from '../../../Advisor_DialogConfirmation/Advisor_DialogConfirmation.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../../_analytics/consts.js';
import './Component_ProtocolGraph.scss';
export class Component_ProtocolGraph extends ComponentSync {
    //######################### Life Cycle ##########################
    deriveStateFromProps(nextProps, state) {
        state.context = nextProps.context;
        state.transitionData = this.calculateTransitionData(state.context);
        state.stateData = this.calculateStateData(state.context);
        return state;
    }
    //######################### Logic ##########################
    calculateTransitionData(context) {
        const allPathwayTransitions = ModuleFE_Advisor_PathwayTransition.cache.filter(t => t.pathwayIds.includes(context.protocolData.pathway._id));
        return allPathwayTransitions.reduce((map, transition) => {
            const params = {};
            map[transition._id] = { entityId: transition._id, params };
            const nextStep = context.nextSteps.find(step => step.transition._id === transition._id);
            const activeState = ModuleFE_RuntimeActiveNavState.cache.find(activeState => activeState.sourceTransitionId === transition._id);
            if (nextStep) {
                params.goto = nextStep.transitionCondition === TransitionCondition.GO_TO_TRANSITION ? true : undefined;
                params.resolvedFalse = nextStep.transitionCondition === TransitionCondition.RES_FUNC_FALSE ? true : undefined;
                params.missingInfo = (!params.resolvedFalse && !params.goto) ? true : undefined;
            }
            if (activeState)
                map[transition._id].params.visited = true;
            return map;
        }, {});
    }
    calculateStateData(context) {
        const allPathwayStates = ModuleFE_Advisor_PathwayState.cache.filter(s => s.pathwayIds.includes(context.protocolData.pathway._id));
        return allPathwayStates.reduce((map, state) => {
            map[state._id] = { entityId: state._id, params: {} };
            const activeState = ModuleFE_RuntimeActiveNavState.cache.find(activeState => activeState.stateDbId === state._id);
            if (activeState)
                map[state._id].params.visited = true;
            return map;
        }, {});
    }
    jumpToState = (stateId) => {
        const protocolData = this.state.context.protocolData;
        if (!protocolData)
            throw new MUSTNeverHappenException('cannot call this state without a selected protocol');
        const state = ModuleFE_Advisor_PathwayState.cache.unique(stateId);
        if (!state)
            throw new MUSTNeverHappenException(`cannot find state with id ${stateId}`);
        //Report analytics event
        ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_goto_open({
            method: 'graph',
            protocolId: protocolData.protocol._id,
            protocolLabel: protocolData.pathway.label
        });
        Advisor_DialogConfirmation.show({
            confirmCallback: async () => {
                try {
                    await ModuleFE_EMInterface.vv1.navigator.goToState({
                        protocolId: protocolData.protocol._id,
                        targetState: stateId
                    }).executeSync();
                    //Report analytics event
                    ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_goto_submit();
                }
                catch (err) {
                    this.logError(`Failed going to transition ${err}`);
                }
            },
            cancelCallback: () => {
                //Report analytics event
                ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_goto_abandon();
            },
            content: () => _jsxs(_Fragment, { children: ['Are you sure you want to jump to ', _jsxs("span", { style: { fontWeight: '600', fontSize: '15px' }, children: [capitalizeAllFirstLetters(state.name), "?"] })] }),
            confirmButtonLabel: 'Jump'
        });
    };
    //######################### Render ##########################
    render() {
        const context = this.state.context;
        const activeStateId = context.protocolData.getActiveState()?.stateDbId;
        const activeStateDoc = ModuleFE_Advisor_PathwayState.cache.unique(activeStateId);
        const activeState = activeStateDoc ? new EditableItem(activeStateDoc).setSaveAction(async (i) => i) : undefined;
        return _jsx(Pathway_GraphView, { pathwayId: context.protocolData.pathway._id, disabled: ModuleFE_EMInterface.isReadonly() || ModuleFE_EMInterface.isPostDisposition(), hideFocusEntity: true, hideTransitionAB: true, zoomScale: [0.2, 5], editablePathwayState: activeState, pathwayStateModule: ModuleFE_Advisor_PathwayState, onStateDoubleClicked: this.jumpToState, pathwayTransitionModule: ModuleFE_Advisor_PathwayTransition, graphvizOptions: { fit: true }, focusedStates: this.state.stateData, focusedTransitions: this.state.transitionData });
    }
}
//# sourceMappingURL=Component_ProtocolGraph.js.map